$(document).ready(function()
{
    if ( $('.js-slick').length )
    {
      $(".js-slick").slick({
          dots: true
      });
    }

    if ( $('.js-background-video').length )
    {

      $(".js-background-video").each(function()
      {
          var playerContainer = $(this);

          if($(this).hasClass('youtube'))
          {
              $(this).YTPlayer({
                  videoId: $(this).data('video-id'),
                  playerVars: {
                      playlist: $(this).data('video-id'),
                      loop: 1
                  },
                  fitToBackground: false,
                  width: 	$(this).width(),
                  callback: function() {
                      $(playerContainer).addClass('js-remove-background')
                  }
              });
          };

      });
    }

    var initialSlideSlick = 0;
    if ( $('.nav-slick').length )
    {
      $('.nav-slick').on('init', function()
      {
          var m = $(this).find("[data-starthere]");
          if (m && m !== undefined)
          {
            initialSlideSlick = parseInt(m.attr("data-starthere"));
          }
      });

      $(".nav-slick").slick({
        dots: true,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        //initialSlide: initialSlideSlick,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      
      });


      $('.nav-slick').slick('slickGoTo', initialSlideSlick); // move to the previous item as first
    }

    if ( $('.news-slick').length )
    {
      $(".news-slick").slick({
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      
      });
    }
    if ( $('.card-slick').length )
    {
      $(".card-slick").slick({
          dots: true,
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [
              {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                      infinite: true,
                      dots: true
                  }
              },
              {
                  breakpoint: 600,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                  }
              }
          ]

      });
    }
});